module.exports = __webpack_public_path__ + "static/media/ye.58d8d563.svg";